// eslint-disable-next-line no-unused-vars
import React from 'react';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import StripePayment from '../components/stripe/StripePayment';
import { useAuth } from '../hooks/useAuth';
import { Navigate} from 'react-router-dom';

const PurchasePage = () => {
  const {user } = useAuth();


  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title="PurchasePage" />
      <StripePayment/>
    </PageContentComponent>
  );
};

export default PurchasePage;
